<template>
  <emd-modal
    has-header
    has-footer
    footerButtonsOnRight
    :open="isOpen"
    @close="() => $emit('onClose')"
  >
    <template v-slot:header>
      <h2 class="emd-text _size_section _color_contrast">
        {{ $t('modal.boleto-stone.modal-disable.title') }}
      </h2>
    </template>
    <template v-slot:content>
      <emd-alert
        v-if="error"
        variant="danger"
        @cancel="error = null"
        :title="$t('account.settings.alert.error-title')"
      >
        <template slot="content">
          {{ error }}
        </template>
      </emd-alert>
      <p class="emd-text _color_subtle">
        {{ $t('modal.boleto-stone.modal-disable.paragraph-1.first') }}
        <strong>
          {{ $t('modal.boleto-stone.modal-disable.paragraph-1.second') }}
        </strong>
      </p>
      <br />
      <p class="emd-text _color_subtle">
        {{ $t('modal.boleto-stone.modal-disable.paragraph-2') }}
      </p>
      <password-confirmation
        class="eu-mt_2"
        :label="$t('modal.password.type-password')"
        :value="password"
        @input="onChangePassword"
      />
    </template>
    <template v-slot:footer>
      <emd-button
        size="big"
        color="danger"
        type="outline"
        :disabled="isLoad"
        @click="() => $emit('onClose')"
      >
        {{ $t('modal.boleto-stone.modal-disable.button-cancel') }}
      </emd-button>
      <emd-button
        size="big"
        color="danger"
        :disabled="isLoad || !password"
        @click="onDisable"
      >
        <emd-loader
          v-if="isLoad"
          type=""
        ></emd-loader>
        <span v-if="!isLoad">
          {{ $t('modal.boleto-stone.modal-disable.button-disable') }}
        </span>
      </emd-button>
    </template>
  </emd-modal>
</template>

<script>
import {
  EmdAlert,
  EmdButton,
  EmdLoader,
  EmdModal
} from 'emerald-vue/src/components'
import PasswordConfirmation from '@/components/project/molecules/PasswordConfirmation'

export default {
  name: 'ModalDisable',
  components: {
    EmdAlert,
    EmdButton,
    EmdLoader,
    EmdModal,
    PasswordConfirmation
  },
  props: {
    isOpen: {
      type: Boolean,
      required: true
    },
    isLoad: {
      type: Boolean,
      required: true
    },
    error: {
      type: String,
      default: () => ''
    }
  },
  data () {
    return {
      password: '',
      inputType: 'password'
    }
  },
  methods: {
    onDisable () {
      this.$emit('onDisable', window.btoa(this.password))
    },
    onChangePassword (password) {
      this.password = password
    }
  }
}
</script>
